import { default as index11uayCMbvVMeta } from "/app/landing/pages/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/landing/pages/index.vue").then(m => m.default || m)
  }
]